import React from 'react';

import { SSRBaseGrid } from '../ssr-base-grid';
import {
  RequestNumberColumn,
  OrderNumberColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  AmountColumn,
  StoreIconColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  SourceColumn,
} from '../../grids/columns';
import { NoFlaggedReturnsPlaceholder } from '../../grids/placeholders/no-flagged-returns-placeholder';

const columns = [
  RequestNumberColumn,
  StoreIconColumn,
  OrderNumberColumn,
  SourceColumn,
  CreateDateColumn,
  CustomerNameColumn,
  CustomerEmailColumn,
  TrackingNumberColumn,
  CarrierServiceColumn,
  AmountColumn,
];

const viewSpecificFilters: any[] = []; // oxlint-disable-line @typescript-eslint/no-explicit-any

export const SSRFlaggedGrid = () => {
  return <SSRBaseGrid columns={columns} noResultsPlaceholder={<NoFlaggedReturnsPlaceholder />} viewSpecificFilters={viewSpecificFilters} />;
};
